/* Enter Harewick — goes in assets/harewick.js */
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scenes = Array.prototype.slice.call(root.querySelectorAll('.hw-scene'));
    var nav = root.querySelector('.hw-path');
    var links = Array.prototype.slice.call(root.querySelectorAll('.hw-path a'));
    var travel = parseFloat(root.dataset.parallax);
    if (isNaN(travel)) travel = 160;
    var ticking = false;

    /* keep the wordmark and path legible against whichever scene is showing */
    var light = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        root.style.setProperty('--hw-now-fg', entry.target.dataset.fg);
        var id = entry.target.id;
        links.forEach(function (link) {
          link.setAttribute('aria-current', link.getAttribute('href') === '#' + id ? 'true' : 'false');
        });
        if (nav) nav.classList.toggle('is-visible', id.indexOf('hw-gate-') !== 0);
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    scenes.forEach(function (s) { light.observe(s); });

    /* bring the copy in once, on arrival */
    var arrive = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          arrive.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -25% 0px' });
    root.querySelectorAll('.hw-scene:not(.hw-gate) .hw-copy').forEach(function (c) {
      arrive.observe(c);
    });

    if (reduce || travel === 0) return;

    var move = function () {
      var vh = window.innerHeight;
      scenes.forEach(function (scene) {
        var rect = scene.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var span = rect.height - vh;
        var progress = span > 0 ? -rect.top / span : 0;
        progress = Math.max(0, Math.min(1, progress));
        scene.querySelectorAll('.hw-layer').forEach(function (layer) {
          var speed = parseFloat(layer.dataset.speed) || 0;
          layer.style.transform = 'translateY(' + ((progress - 0.5) * speed * -travel) + 'px)';
        });
        var asset = scene.querySelector('.hw-asset');
        if (asset) {
          asset.style.transform = 'translateY(' + ((progress - 0.5) * -60) + 'px)';
        }
      });
      ticking = false;
    };

    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(move); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', move, { passive: true });
    move();
  }

  function boot() {
    document.querySelectorAll('.harewick').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* re-run when you edit things in the theme customizer */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.harewick');
    if (root) { delete root.dataset.ready; init(root); }
  });
})();